<template>
  <div>
    <modal :showDialog="activeModal === 'CHECKUP'" @close="closeCheckupModal" :title="$t('CHECKUP')">
		<checkup-modal :system="{systemId, systemName}" @cancel="closeCheckupModal" @save="closeCheckupModal"></checkup-modal>
	</modal>
  <!-- Siatka w osobnym elemencie: korzeń dostaje z Main.vue stałą wysokość (router-view),
       a wiersze siatki muszą rosnąć z treścią kafli. -->
  <div class="general-system-container" style="width: 100%; padding: 10px;">
    <div class="system-general-area system-area">
      <div style="text-align: center; margin: 10px;">
        <span style="font-weight: bold; font-size: 25px;">{{$t('General')}}</span>
        <div style="margin: 10px; overflow-y: auto;">
          <table style="width: 100%;">
            <tr v-for="stats in statisticsToShow" :key="stats.field" class="info-field">
              <td style="text-align: left;" class="info-field-title">{{ $t(stats.header) }}</td>
              <td style="text-align: right;" class="info-field-value">{{ generalData[stats.field] }}</td>
            </tr>
          </table>
          <div v-if="!$store.getters.isUser">
            <Button :title="$t('SetAsChecked')" :buttonClass='generalData.checkupDone ? "cancel-button semi-bold" : "save-button semi-bold"' style="width: 150px; float: right; margin-top: 10px;" @onClick="checkupDone" :disabled="generalData.checkupDone"></Button>
          </div>
        </div>
      </div>
    </div>
    <!-- Contact -->
    <div v-if="!$store.getters.isUser" class="system-contact-area system-area">
        <div style="text-align: center; margin: 10px;">
          <span style="font-weight: bold; font-size: 25px;">{{$t('Contact')}}</span>
          <div style="overflow-x: auto">
            <div style="display: flex; flex-direction: column; flex: 1; height: 100%;">
              <ejs-grid ref="grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true"  :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="contacts" :allowPaging="false" :allowFiltering='false' :allowSorting='true' :allowMultiSorting='true' :showBusyIndicator="true">
                <e-columns>
                  <e-column field='fullName' :headerText="$t('FullName')" textAlign='Left' :template="TextTemplate" :customAttributes="customAttributes"></e-column>
                  <e-column :visible="!$store.getters.isMobile"  field='email' :headerText="$t('Email')" textAlign='Left' :template="TextTemplate" :customAttributes="customAttributes"></e-column>
                  <e-column field='phoneNumber' :headerText="$t('PhoneNumber')" textAlign='Left' :template="TextTemplate" :customAttributes="customAttributes" :valueAccessor="valueAccessorPhoneNumber"></e-column>
                  <e-column :visible="!$store.getters.isMobile" field='description' :headerText="$t('Description')" textAlign='Left' :template="TextTemplate" :customAttributes="customAttributes"></e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>
    </div>
    <!-- External -->
    <div v-if="!$store.getters.isUser" class="system-external-area system-area">
        <remote-access :systemId="systemId" :systemName="systemName"></remote-access>
    </div>
    <!-- Herd weight -->
    <div class="system-external-area system-area" v-if="systemData != null && systemData.hasWeight">
        <div style="text-align: center; margin: 10px;">
          <span style="font-weight: bold; font-size: 25px;">{{$t('Herd weight')}}</span>
          <sci-chart-herd-weight :systemId="systemId"/>
        </div>
    </div>
    <!-- Map -->
    <div id="map-container" class="system-map-area system-area" style="position: relative; display: inline-block;">
      <div id="map" ref="map" style="position: absolute; z-index: 1;"></div>
      <div style="position: absolute; z-index: 2; background-color: white; top: 10px; left: 10px; padding-top: 5px; padding-bottom: 5px; padding-left: 10px; padding-right: 10px; border-radius: 5px; max-width: 90%; cursor: pointer;" class="vertical" @click="openMap">
        <span style="font-weight: bold;">{{$t('SystemAddress')}}</span>
        <span style="margin-top: 5px;">{{system.address}}</span>
        <span>{{system.country}}</span>
      </div>
    </div>
    <!-- Photos -->
    <div v-if="photos.length != 0" class="system-photos-area system-area">
      <div id="photos-container" style="padding-top: 10px; padding-bottom: 10px;">
        <div style="text-align: center;">
          <span style="font-weight: bold; font-size: 25px;">{{$t('Photos')}}</span>
          <div class="vertical" style="height: 100%; justify-content: space-between;" v-if="photos.length > 0">
            <div style="width: 97%; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;">
              <i class="arrow left" :style="[photos.length > 1 ? { 'cursor': 'pointer' } : { 'cursor': 'default' }]" @click="prevPhoto"></i>
              <img class="photo" :src="photos[activePhotoIndex].src">
              <i class="arrow right" :style="[photos.length > 1 ? { 'cursor': 'pointer' } : { 'cursor': 'default' }]" @click="nextPhoto"></i>
            </div>
            <div class="thumbnails horizontal">
              <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                <img :src="photo.src" class="thumbnail" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { getSystemImage, getSystemFarmById, getContactsBySystemId, getSystemGeneralData, getRemoteAccessForSystem, deleteRemoteAccess, updateSystemCheckupDone } from '@/api/api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import mapboxgl from 'mapbox-gl';
import libphonenumber from 'google-libphonenumber';
import countriesDataJson from '@/assets/json/countries.json'
import Modal from '@/components/Modal.vue'
import RemoteAccess from '@/components/Settings/General/RemoteAccess.vue';
import Button from "@/components/Button";
import DeleteConfirm from '@/components/DeleteConfirm.vue'
import ProbablyOverflowingTextCellVue from '../../components/Systems/ProbablyOverflowingTextCell.vue';
import CheckupModal from '../../components/Systems/CheckupModal.vue';
import SciChartHerdWeight from '../../components/Charts/SciChartHerdWeight.vue';

export default {
    props: ['systemId', 'systemName', 'systemData'],
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport]
    },
    components: {
        Modal,
        Button,
        DeleteConfirm,
        RemoteAccess,
        ProbablyOverflowingTextCellVue,
        CheckupModal,
        SciChartHerdWeight
    },
    data() {
        return {
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            customAttributes: { class: 'customcss' },
            system: {},
            photos: [],
            activePhotoIndex: 0,
            map: null,
            contacts: [],
            phoneUtil: null,
            PNF: null,
            countriesData: null,
            generalData: {},
            resizeObs: null,
            activeModal: 'NONE',
            statisticsToShow: [
                { field: "devicesCount", header: 'NumberOfDevices' },
                { field: "uiSoftwareVersion", header: 'SoftwareVersionUi' },
                { field: "apiSoftwareVersion", header: 'SoftwareVersionAPI' },
                { field: "blackBoxSoftwareVersion", header: 'SoftwareVersionBlackBox' },
                { field: "diagnosticSoftwareVersion", header: 'SoftwareVersionDiagnostic' },
                { field: "systemSoftwareVersion", header: 'SoftwareVersionSystem' },
                { field: "alarmsToday", header: 'NumberOfAlarmsToday' },
                { field: "alarmsYesterday", header: 'NumberOfAlarmsYesterday' },
                { field: "installationDate", header: 'InstallationDate' },
                { field: "underWarranty", header: 'UnderWarranty' },
                { field: "serviceAgreement", header: 'ServiceAgreement' },
                { field: "lastCheckup", header: 'LastCheckupDate' },
                { field: "checkupPerson", header: 'LastCheckupPerson' }
            ],
            TextTemplate: function() {
                return {
                    template: {
                        extends: ProbablyOverflowingTextCellVue
                    }
                }
            }
        }
    },
    methods: {
        // Formatuje datę opcjonalną: null/pusta lub sentinel „brak daty" (rok < 2011) → "-".
        formatOptionalDate(value) {
            if (!value) {
                return "-"
            }
            var dt = new Date(Date.parse(value))
            if (isNaN(dt.getTime()) || dt.getFullYear() < 2011) {
                return "-"
            }
            return value.toDate()
        },
        async getData() {
            this.$emit('spin', true);
            this.getSystemData();

            if(!this.$store.getters.isUser) {
                this.getContactsData();
            }
            
            await this.getGeneralSystemData();
            this.$emit('spin', false)
        },
        async getGeneralSystemData(){
            this.generalData = await getSystemGeneralData(this.systemId);
            // Daty mogą być null („brak daty") lub sentinelem sprzed 2011 — pokazujemy "-".
            this.generalData.installationDate = this.formatOptionalDate(this.generalData.installationDate)
            this.generalData.underWarranty = this.formatOptionalDate(this.generalData.underWarranty)
            this.generalData.serviceAgreement = this.formatOptionalDate(this.generalData.serviceAgreement)

            if (this.generalData.lastCheckup == "0001-01-01T00:00:00") {
              this.generalData.lastCheckup = "Never";
              this.generalData.checkupDone = false;
            } else {
              const currentDate = new Date();
              if (new Date(this.generalData.lastCheckup).toDateString() == currentDate.toDateString()) {
                this.generalData.checkupDone = true;
              } else {
                this.generalData.checkupDone = false;
              }
              this.generalData.lastCheckup = this.generalData.lastCheckup.toDate()
            }

        },
        async getSystemData() {
            this.system = await getSystemFarmById(this.systemId);

            for (let i = 0; i < this.system.images.length; i++) {
                let img = await getSystemImage(this.system.images[i]);
                let photo = URL.createObjectURL(new Blob([img.data], {
                    type: img.headers['content-type']
                }));

                this.photos.push({
                    src: photo,
                    thumbnail: photo,
                    id: this.system.images[i]
                });
            }
        },
        async getContactsData() {
            this.contacts = await getContactsBySystemId(this.systemId);
        },
        nextPhoto() {
            if (this.activePhotoIndex + 1 < this.photos.length) {
                this.activePhotoIndex++;
            }
        },
        prevPhoto() {
            if (this.activePhotoIndex > 0) {
                this.activePhotoIndex--;
            }
        },
        keyDownListener(e) {
            switch (e.key) {
                case 'ArrowLeft':
                    this.prevPhoto();
                    break;
                case 'ArrowRight':
                    this.nextPhoto();
                    break;
            }
        },
        createMap() {
            mapboxgl.accessToken = 'pk.eyJ1Ijoicml2aWpjenlrOTgiLCJhIjoiY2thNWxvYnZ4MDFhcjNtbXdlOGRkZHlpNyJ9.3yvf9A68MAvVM9OG1ZK9pg';

            this.map = new mapboxgl.Map({
                container: 'map', // container ID
                style: 'mapbox://styles/mapbox/streets-v12', // style URL
                center: [this.generalData.addressLongitude, this.generalData.addressLatitude], // starting position [lng, lat]
                zoom: 5 // starting zoom
            });

            this.map.addControl(new mapboxgl.NavigationControl());

            var marker = new mapboxgl.Marker({ color: ['#3CD6B1', '#FFBD6D', '#FF6666', '#AAAAAA'][this.system.lastUpdate != undefined && this.system.lastUpdate == '0001-01-01T00:00:00' ? 3 : this.system.statusTab[0][1]] })
                .setLngLat([this.generalData.addressLongitude, this.generalData.addressLatitude])
                .setPopup()
                .addTo(this.map);
        },
        dataBound: function () {
          this.$refs.grid.autoFitColumns();
          // this.$refs.gridAccess.autoFitColumns();
        },
        valueAccessorPhoneNumber: function(field, data1, column) {
            if (data1[field]) {
                var country = data1['country'];

                if (data1['country'] == 'Northern Ireland') {
                    country = 'United Kingdom'
                }

                var code = this.countriesData.filter(x => x.name.common == country || x.name.official == country || x.altSpellings.includes(country))[0];

                if (code != undefined) {
                    var number = this.phoneUtil.parseAndKeepRawInput(data1[field], code.cca2);
                    var numberForm = this.phoneUtil.format(number, this.PNF.INTERNATIONAL)
                    return numberForm
                }
            }

            return data1[field];
        },
        openMap() {
            var lat = this.generalData.addressLatitude;
            var lng = this.generalData.addressLongitude;
            var url = "https://www.google.com/maps/search/?api=1&query=" + lat + "," + lng;

            window.open(url, '_blank')
        },
        async checkupDone() {
          this.activeModal = 'CHECKUP'
        },
        async closeCheckupModal() {
            this.activeModal = 'NONE'
            this.getData();
        }
    },
    mounted: async function () {
      this.phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
      this.PNF = libphonenumber.PhoneNumberFormat;
      this.countriesData = countriesDataJson;

      await this.getData();
      this.createMap();

      document.addEventListener("keydown", this.keyDownListener);

      this.resizeObs = new ResizeObserver((entr) => {
              this.map.resize()
          })

          this.resizeObs.observe(document.querySelector('#map-container'))

    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.keyDownListener);

        var element = document.querySelector('#map-container')
        if(element != null) {
            this.resizeObs.unobserve(element)
        }
    }
}
</script>

<style scoped>
.table {
    border-top: none;
    border-left: none;
    border-right: none;
}

.table tbody {
    border-left: 1px solid #A3D4E0;
    border-right: 1px solid #A3D4E0;
}

.e-grid .e-headercell.customcss {
    padding: 0 5px 0 5px;
}

.e-grid .e-headercell .e-headercelldiv {
    padding-right: 5px;
}

.e-gridchkbox.customcss .e-checkbox-wrapper {
    vertical-align: middle;
}
#photos-container {
    width: 100%;
    height: 100%;
}
.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    width: 4%;
    height: 0;
    padding-bottom: 4%;
}

.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
}
.photo {
    margin: 0 auto 0 auto;
    border-radius: 4px;
    object-fit: contain;
    width: 88%;
    height: 100%;
}
.thumbnails {
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: 80%;
    margin: 0 auto 0 auto;
}

.thumbnail {
    width: 61px;
    height: 61px;
    margin: 5px;
    object-fit: cover;
    cursor: pointer;
    background: #34758E;
    border-radius: 4px;
    position: initial;
}
#map {
    height: 100%;
    width: 100%;
    background: white;
    border-radius: 5px;
}
.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}
.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field td {
    padding: 8px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #272727;
}
.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: #272727;
}

.general-system-container {
    display: grid;
    gap: 16px;
    align-content: start;
    /* Kafle min. 400px szerokości, ale maks. 3 w rzędzie (min. 1/3 szerokości
       minus odstępy) — na szerokich ekranach nie rozciągają się w wąskie paski.
       Poniżej ~850px kontenera kafle układają się jeden pod drugim. */
    grid-template-columns: repeat(auto-fit, minmax(max(400px, calc((100% - 32px) / 3)), 1fr));
    grid-auto-rows: minmax(420px, auto);
    grid-auto-flow: row dense;
}

@media (max-width: 480px) {
    .general-system-container {
        grid-template-columns: 1fr;
    }
}

/* .system-general-area {
    grid-row-start:    general-start;
    grid-row-end:      general-end;
    grid-column-start: general-start;
    grid-column-end:   general-end;
}

.system-contact-area {
    grid-row-start:    contact-start;
    grid-row-end:      contact-end;
    grid-column-start: contact-start;
    grid-column-end:   contact-end;
}

.system-map-area {
    grid-row-start:    map-start;
    grid-row-end:      map-end;
    grid-column-start: map-start;
    grid-column-end:   map-end;
}
.system-external-area {
    grid-row-start:    external-start;
    grid-row-end:      external-end;
    grid-column-start: external-start;
    grid-column-end:   external-end;
}
.system-photos-area {
    grid-row-start:    photos-start;
    grid-row-end:      photos-end;
    grid-column-start: photos-start;
    grid-column-end:   photos-end;
} */

.system-area {
    background: rgba(243, 243, 243, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 5px;
    min-width: 0;
    overflow: auto;
}

.system-map-area {
    min-height: 300px;
}
</style>

<style>
.tippy-tooltip.customTheme-theme {
    background-color: #346F8B;
}

.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
    border-left: 8px solid #346F8B;
}
</style>



// WEBPACK FOOTER //
// src/views/System/SettingsGeneral.vue